'use strict';

var $ = require('jquery');
var Analytics = require('@plaudit/analytics').Analytics;
var myAnalytics = Analytics.getInstance();

/**
 * Triggers active class on element based on click of trigger
 * @param {{item: string}} config
 */
function Accordion(config) {
	this.config = $.extend({}, {
		item: 'accordionItem',
		doStartOpen: false,
		startOpenIndex: [0]
	}, config);
	this.active = false;

	this.config.itemSelector =
			this.config.itemSelector
			? this.config.itemSelector
			: '.' + this.config.item + ':has(.' + this.config.item + '__heading)'
		;
}

Accordion.prototype.init = function () {
	var that = this;
	this.active = true;
	
	this.$item = $(this.config.itemSelector);

	function ajaxRefresh() {
		that.$item = $(that.config.itemSelector);
		if (that.$item.length >= that.config) {
			that.attachHandlers();
			that.startOpen();
		}
	}

	// Needs to be reinitialized if ajax ran
	if (!this.$item.length) {
		$(document).on('jsfAjaxAlways.accordion', ajaxRefresh);
		return;
	}

	this.attachHandlers();
	this.startOpen();
};

Accordion.prototype.attachHandlers = function () {
	var that = this;

	$('.' + this.config.item + '__heading').on('click.accordion', function(event) {
		event.preventDefault();

		var accordionElement = $(this).closest(that.$item);
		that.toggleAccordion(accordionElement);
	});
};

/**
 * Toggles the accordion open or closed.
 * @param {HTMLElement} accordion The selected accordion element
 * @param {Boolean} [noninteraction=false] Whether to not trigger the GA event
 */
Accordion.prototype.toggleAccordion = function(accordion, noninteraction) {
	if ($(accordion).hasClass(this.config.item + '--active')) {
		$(accordion).removeClass(this.config.item + '--active');
	} else {
		$(accordion).addClass(this.config.item + '--active');

		if (!noninteraction) {
			var label = '';
			var headingEl = $(accordion).find('.' + this.config.item + '__heading');
			console.log(headingEl);
			if (headingEl.length) {
				label = headingEl[0].textContent.trim();
			}
			myAnalytics.trackEvent('Accordion', 'Expand', label);
		}
	}
};

Accordion.prototype.startOpen = function() {
	if (this.config.doStartOpen) {
		for (var index = 0; index < this.config.startOpenIndex.length; index++) {
			var elementIndex = this.config.startOpenIndex[index];
			this.toggleAccordion(this.$item[elementIndex], true);
		}
	}
}

Accordion.prototype.destroy = function() {
	this.active = false;

	$('.' + this.config.item + '--active').removeClass(this.config.item + '--active');
	$('.' + this.config.item + '__heading').off('click.accordion');
	$(document).off('jsfAjaxAlways.accordion');
}

module.exports = Accordion;
